<script>
import Layout from '@layouts/main'
import { hmdaMethods } from '@state/helpers'
import { hmdaACL } from '@/src/utils/accesslevels'
import common from '@/src/state/modules/common'
import HmdaHeader from '@/src/components/HMDA/HmdaHeader.vue'
import constant from '@constants/constant'

export default {
  components: { Layout, HmdaHeader },
  data() {
    return {
      myUsername: '',
      showSpinner: false,
      larHistory: [],
      headerTitle: 'LAR Summary',
      breadcrumbs: [
        {
          text: 'Home',
          to: { path: '/home' },
        },
        {
          text: 'HMDA',
          to: { path: '/hmda' },
        },
        { text: 'LAR Summary', active: true },
      ],
      customer: null,
      textTooltipMessage: constant.hmdaTooltip.text,
      csvTooltipMessage: constant.hmdaTooltip.csv,
    }
  },
  computed: {
    LOAN_ID() {
      return this.$route.params.id || '0'
    },
  },
  async mounted() {
    hmdaACL.initializeAccessControls()
    await this.getSelectedCustomer().then((res) => {
      this.customer = res
    })
    this.fetchLARS()
  },
  methods: {
    ...hmdaMethods,
    onClickLARErrors(item) {
      this.$refs.errorView.showAsync(
        item.errorMsg || 'No Message',
        'LAR Error',
        'Close'
      )
    },
    genLink(item) {
      return { name: 'hmda-project-details', params: { id: item.projectId } }
    },
    async onClickApprove(item) {
      this.showSpinner = true
      this.approveLARDownload(item.larSummaryId)
        .then((e) => {
          if (e === true) {
            this.fetchLARS()
          }
        })
        .finally(() => {
          this.showSpinner = false
        })
    },
    async onClickLARDownload(item, fileType) {
      this.showSpinner = true
      this.downloadLAR({
        larSummaryId: item.larSummaryId,
        customerId: this.customer.value,
        customerName: this.customer.text,
        filetype: fileType,
      })
        .then((response) => {
          if (response.data.isSuccess) {
            common.downloadFile(
              response.data.byteArray,
              response.data.fileFormat,
              this.getFileName(fileType, item.approvedDate),
              true
            )
          } else {
            this.fetchLARS()
          }
        })
        .finally(() => {
          this.showSpinner = false
        })
    },
    getFileName(type, date) {
      let fileName
      switch(type){
        case 'text': fileName = 'lar-file'
          break
        case 'csv': fileName = 'lar-file_' + date.replaceAll("/","").split(" ")[0]
          break
      }
      return fileName
    },
    async fetchLARS() {
      this.showSpinner = true
      this.fetchLARSummary({
        pageNo: 1,
        pageSize: 50,
        customerId: this.customer.value > 0 ? this.customer.value : 0,
      })
        .then((r) => {
          r.forEach((b) => {
            b.isSelected = false
            // b.errorMessage = 'e'
            // b.isSuccess=false
          })
          this.larHistory = r
        })
        .finally(() => {
          this.showSpinner = false
        })
    },
  },
}
</script>

<template>
  <Layout>
    <BaseSpinner v-if="showSpinner" />
    <BaseModalLayout ref="msg" modal-size="md" />
    <BaseModalLayout ref="errorView" hide-cancel modal-size="md" />
    <HmdaHeader :crumbs="breadcrumbs" />
    <div class="body--wrapper mt-1  bg-white container">
      <BaseTitleMenu
        heade-title="LAR Summary"
        class="text-capitalize border-bottom pb-3"
      />
      <p>
        Listing all LAR requests and status
      </p>

      <b-row class="mt-5">
        <b-col>
          <!-- <h6 class="muted">LAR History</h6> -->
          <b-table-simple responsive hover sortable>
            <thead>
              <b-tr>
                <b-th>Projects</b-th>
                <b-th>Year/Quarter</b-th>
                <b-th>Request Info</b-th>
                <b-th>Approval Info</b-th>
                <b-th>LAR File</b-th>
                <b-th>Errors</b-th>
                <!-- <b-th>Action Taken Dates</b-th>
                <b-th>CFPB Action</b-th>
                <b-th>Upload Info</b-th> -->
              </b-tr>
            </thead>
            <tbody>
              <template v-for="(b, bi) in larHistory">
                <b-tr :key="`tr1_${bi}`">
                  <b-td>
                    <BaseEButton
                      variant="icon"
                      :icon="`angle-double-${b.isSelected ? 'up' : 'down'}`"
                      dense
                      class="mt-3 border-0"
                      pill
                      @click="b.isSelected = !b.isSelected"
                    />
                  </b-td>
                  <!-- Year/Quarter -->
                  <b-td class="py-2">
                    <div class="mx-2">
                      {{ b.yearQuarter }}
                    </div>
                  </b-td>
                  <b-td class="py-2">
                    <div>
                      <BaseIcon name="user" />
                      <span class="pl-2">{{ b.requestedBy || '--' }}</span>
                    </div>
                    <div>
                      <BaseIcon name="clock" />
                      <span class="pl-2">{{ b.requestedDate || '--' }}</span>
                    </div>
                  </b-td>

                  <b-td class="py-2">
                    <template v-if="!b.approvedBy">
                      <template v-if="b.canApprove">
                        <BaseEButton
                          :id="`biapprove_${bi}`"
                          @click="() => onClickApprove(b)"
                          >Approve</BaseEButton
                        >
                        <b-tooltip :target="`biapprove_${bi}`" triggers="hover">
                          Approve for LAR Download
                        </b-tooltip>
                      </template>
                      <template v-else>
                        Awaiting Approval
                      </template>
                    </template>
                    <!-- <span v-if="!b.fileName">
                      Awaiting file...
                    </span> -->
                    <template v-else>
                      <div>
                        <BaseIcon name="user" />
                        <span class="pl-2">{{ b.approvedBy || '--' }}</span>
                      </div>
                      <div>
                        <BaseIcon name="clock" />
                        <span class="pl-2">{{ b.approvedDate || '--' }}</span>
                      </div>
                    </template>
                  </b-td>

                  <b-td class="py-2">
                    <b-link :id="`textDownload_${bi}`" :disabled="!b.approvedBy" :class="!b.approvedBy ? 'disabledCursor disableLink' : ''" @click="onClickLARDownload(b, 'text')">
                      <span>Text</span>
                      <BaseIcon
                        noninteractive
                        size="lg"
                        name="file"
                        class="mx-1"
                       />
                     </b-link>
                     <span class="border-right mx-2"></span>
                     <!-- CSV option to be integrated with API  -->
                    <b-link :id="`csvDownload_${bi}`" :disabled="!b.approvedBy" :class="!b.approvedBy ? 'disabledCursor disableLink' : ''" @click="onClickLARDownload(b, 'csv')">
                      <span>CSV</span>
                      <BaseIcon
                        noninteractive
                        size="lg"
                        name="file-csv"
                        class="mx-1"
                       />
                     </b-link>
                     <b-tooltip :target="`textDownload_${bi}`" triggers="hover">
                      {{ textTooltipMessage }}
                    </b-tooltip>
                    <b-tooltip :target="`csvDownload_${bi}`" triggers="hover">
                      {{ csvTooltipMessage }}
                    </b-tooltip>
                  </b-td>
                  <b-td class="py-2">
                    <b-link
                      v-if="b.errorMsg"
                      @click="() => onClickLARErrors(b)"
                    >
                      View Error
                    </b-link>
                  </b-td>

                  <!-- <b-td class="pt-2">
                    <BaseEButton
                      :id="`bidownload_${bi}`"
                      variant="icon"
                      icon="download"
                      :disabled="!b.downloadLink"
                      @click="onClickLARDownload"
                    />
                    <b-tooltip :target="`bidownload_${bi}`" triggers="hover">
                      {{
                        b.downloadLink
                          ? 'Download LAR file'
                          : 'File generation in progress'
                      }}
                    </b-tooltip>
                  </b-td> -->

                  <!-- <b-td class="py-2">
                    <div>
                      <BaseIcon name="clock" />
                      <span class="pl-2"
                        >Min: {{ b.minActionDate || '--' }}</span
                      >
                    </div>
                    <div>
                      <BaseIcon name="clock" />
                      <span class="pl-2"
                        >Max: {{ b.maxActionDate || '--' }}</span
                      >
                    </div>
                  </b-td> -->
                  <!-- <b-td class="py-2">
                    <BaseEButton
                      :id="`biup_${bi}`"
                      icon="upload"
                      variant="icon"
                      :disabled="!b.approvedBy"
                      @click="onClickUploadButton"
                    />
                    <b-tooltip :target="`biup_${bi}`" triggers="hover">
                      Upload to CFPB
                    </b-tooltip>
                  </b-td>
                  <b-td class="py-2">
                    <div>
                      <BaseIcon name="user" />
                      <span class="pl-2">{{ b.uploadedBy || '--' }}</span>
                    </div>
                    <div>
                      <BaseIcon name="clock" />
                      <span class="pl-2">{{ b.uploadTime || '--' }}</span>
                    </div>
                  </b-td> -->
                </b-tr>

                <b-tr v-if="b.isSelected" :key="`tr2_${bi}`">
                  <b-td
                    colspan="7"
                    class="pt-3 mb-5 pb-5 border"
                    style="border: 1px solid #3a3a3a !important"
                  >
                    <b-table-simple responsive hover>
                      <thead style="background-color:#bababa">
                        <b-th>Project Name</b-th>
                        <b-th>Project Creation Date</b-th>
                        <b-th>Created By</b-th>
                        <b-th>Min Action Taken Date</b-th>
                        <b-th>Max Action Taken Date</b-th>
                      </thead>
                      <tbody>
                        <b-tr
                          v-for="(sp, spi) in b.projectInfos"
                          :key="`larp_${bi}_${spi}`"
                        >
                          <b-td>
                            <b-link :to="genLink(sp)">{{
                              sp.projectName
                            }}</b-link>
                          </b-td>
                          <b-td>
                            {{ sp.createdDate }}
                          </b-td>
                          <b-td>
                            {{ sp.createdBy }}
                          </b-td>
                          <b-td>
                            {{ sp.minActionTakenDate }}
                          </b-td>
                          <b-td>
                            {{ sp.maxActionTakenDate }}
                          </b-td>
                        </b-tr>
                      </tbody>
                    </b-table-simple>
                  </b-td>
                </b-tr>
              </template>
            </tbody>
          </b-table-simple>
        </b-col>
      </b-row>
    </div>
  </Layout>
</template>
<style lang="scss" scoped>
@import '@design';
.disableLink {
  color: $color-bg-lightGrey;
  text-decoration: none;
}
.disableLink:hover {
  color: $color-bg-lightGrey;
  text-decoration: none;
}
.disableLink > svg {
  color: $color-bg-lightGrey;
}
</style>
